export default __webpack_public_path__ + "a240e39614724f8b42268d04634d3962.svg";